import {Injectable} from '@angular/core';
import {BackOfficeConfig} from "../interfaces/back-office-config";
import {take} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {ConfigService} from "./config.service";

@Injectable({
  providedIn: 'root'
})
export class TranslationService {

  targetStorage: string = '';
  backofficeConfig: BackOfficeConfig = {} as BackOfficeConfig


  constructor(private http: HttpClient, private configService: ConfigService) {
  }

  initializeTranslations(): Promise<boolean> {
      this.backofficeConfig = this.configService.getBackOfficeConfig();
      this.targetStorage = this.backofficeConfig['FLEET_TRANSLATION_TARGET_ON_LOCAL_STORAGE'];
      switch (this.backofficeConfig['TRANSLATION_SOURCE']) {
        case 'LOCAL':
          return this.initializeLocalTranslations()
        case 'BUCKET':
          return this.initializeBucketTranslations()
        case 'BACKOFFICE':
          return this.initializeBackOfficeTranslations(this.backofficeConfig)
        default:
          return new Promise<boolean>((resolve) => {
            resolve(false)
          });
      }
  }

  initializeLocalTranslations(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      const culture = this.backofficeConfig.BACKOFFICE_CONFIG.CULTURE;
      this.http.get(`http://localhost:3000/getTranslation/${culture}`).pipe(take(1)).subscribe((value) => {
        localStorage.setItem(this.targetStorage, JSON.stringify(value))
      });
      resolve(true);
    });
  }

  initializeBucketTranslations(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      const culture = this.backofficeConfig.BACKOFFICE_CONFIG.CULTURE;
      this.http.get(`/fakeoffice/translations/translation_${culture}.json`).pipe(take(1)).subscribe((value) => {
        localStorage.setItem(this.targetStorage, JSON.stringify(value))
      });
      resolve(true);
    });
  }

  initializeBackOfficeTranslations(backofficeConfig: any): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      resolve(true)
    });
  }

  getTranslationForPage(pageName: string): Object {
    const translationFleet = JSON.parse(localStorage.getItem(this.targetStorage) + "");
    if (translationFleet){
      return Object.keys(translationFleet)
        .filter(key => key.split('.')[0] === pageName)
        .reduce((result: any, key: string) => {
          if (translationFleet != null) {
            result[key] = translationFleet[key];
          }
          return result;
        }, {} as { [key: string]: string });
    }
    return {}
  }
}
